import { css } from 'styled-components';
export const BKJThemeBadge = {
    Orange: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.SecondaryPendingDefault};
  `,
    OrangePill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.SecondaryPendingDefault};
    border-radius: 19px;
  `,
    Green: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.SecondaryAcceptedDefault};
  `,
    GreenPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.SecondaryAcceptedDefault};
    border-radius: 19px;
  `,
    Red: css `
    color: ${({ theme }) => theme.colors.White};
    background-color: ${({ theme }) => theme.colors.ErrorDefault};
  `,
    RedPill: css `
    color: ${({ theme }) => theme.colors.White};
    background-color: ${({ theme }) => theme.colors.ErrorDefault};
    border-radius: 19px;
  `,
    Grey: css `
    color: ${({ theme }) => theme.colors.White};
    background-color: ${({ theme }) => theme.colors.Grey6};
  `,
    GreyPill: css `
    color: ${({ theme }) => theme.colors.White};
    background-color: ${({ theme }) => theme.colors.Grey6};
    border-radius: 19px;
  `,
    LightGrey: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.Grey3};
  `,
    LightGreyPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.Grey3};
    border-radius: 19px;
  `,
    MidGrey: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.Grey4};
  `,
    MidGreyPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.Grey4};
    border-radius: 19px;
  `,
    DarkGrey: css `
    color: ${({ theme }) => theme.colors.White};
    background-color: ${({ theme }) => theme.colors.Grey7};
  `,
    DarkGreyPill: css `
    color: ${({ theme }) => theme.colors.White};
    background-color: ${({ theme }) => theme.colors.Grey7};
    border-radius: 19px;
  `,
    GreyOutline: css `
    border: 1px solid ${({ theme }) => theme.colors.TextSubtleGrey};
    color: ${({ theme }) => theme.colors.TextHighlight1};
    border-radius: 2px;
  `,
    AcceptedPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.ShiftAccepted};
    border-radius: 19px;
  `,
    AssignedPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.ShiftAssigned};
    border-radius: 19px;
  `,
    CancelledPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.ShiftCancelled};
    border-radius: 19px;
  `,
    CompletedPill: css `
    color: ${({ theme }) => theme.colors.TextWhite};
    background-color: ${({ theme }) => theme.colors.ShiftCompleted};
    border-radius: 19px;
  `,
    InProgressPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.ShiftInProgress};
    border-radius: 19px;
  `,
    OpenPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.ShiftOpen};
    border-radius: 19px;
  `,
    PendingPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.ShiftPending};
    border-radius: 19px;
  `,
    RejectedPill: css `
    color: ${({ theme }) => theme.colors.TextWhite};
    background-color: ${({ theme }) => theme.colors.ShiftRejected};
    border-radius: 19px;
  `,
    RequestedPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.ShiftRequested};
    border-radius: 19px;
  `,
    UnfulfilledPill: css `
    color: ${({ theme }) => theme.colors.TextWhite};
    background-color: ${({ theme }) => theme.colors.ShiftUnfulfilledStroke};
    border-radius: 19px;
  `,
    SwappedPill: css `
    color: ${({ theme }) => theme.colors.TextWhite};
    background-color: ${({ theme }) => theme.colors.ShiftSwapped};
    border-radius: 19px;
  `,
    AbsentPill: css `
    color: ${({ theme }) => theme.colors.TextDarkGrey};
    background-color: ${({ theme }) => theme.colors.ShiftAbsent};
    border-radius: 19px;
  `,
    PendingBlockPill: css `
    color: ${({ theme }) => theme.colors.TextHighlight1};
    background-color: ${({ theme }) => theme.colors.ShiftPendingBlock};
    border-radius: 19px;
  `,
};
//# sourceMappingURL=BKJBadge.theme.js.map